// react
import React, { useEffect, useState } from "react";

import AIAssistantPortal from "./portals/AiAssistantPortal";

function Review() {
	const [elementIDs, setElementIDs] = useState<string[]>([]);
	useEffect(() => {
		const findAiAbleElements = () => {
			const elements = document.querySelectorAll('[data-ai-assistant="true"]');
			const ids = Array.from(elements).map(
				(el) => el.getAttribute("id")?.replace("-text-area-question", "") || ""
			);
			setElementIDs(ids.filter(Boolean));
		};

		findAiAbleElements();

		// Listen to DOM changes using MutationObserver
		const observer = new MutationObserver(() => {
			findAiAbleElements();
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		return () => {
			observer.disconnect();
		};
	}, []);

	return (
		<>
			{elementIDs.map((elementID) => (
				<AIAssistantPortal key={`portal-${elementID}`} elementId={elementID} />
			))}
		</>
	);
}

export default Review;
